import { defineMessages } from 'react-intl';

export default defineMessages({
  'timezone.gmt-12:00,1': {
    id: 'gmt-12:00-1',
    defaultMessage: '(GMT-12:00) International Date Line West',
    tz: 'Etc/GMT+12',
  },
  'timezone.gmt-11:00.1': {
    id: 'gmt-11:00-1',
    defaultMessage: '(GMT-11:00) Midway Island, Samoa',
    tz: 'Etc/GMT+11',
  },
  'timezone.gmt-10:00.1': {
    id: 'gmt-10:00-1',
    defaultMessage: '(GMT-10:00) Hawaii',
    tz: 'Etc/GMT+10',
  },
  'timezone.gmt-09:00.1': {
    id: 'gmt-09:00-1',
    defaultMessage: '(GMT-09:00) Alaska',
    tz: 'Etc/GMT+9',
  },
  'timezone.gmt-08:00.1': {
    id: 'gmt-08:00-1',
    defaultMessage: '(GMT-08:00) Pacific Time (US & Canada)',
    tz: 'Etc/GMT+8',
  },
  'timezone.gmt-08:00.2': {
    id: 'gmt-08:00-2',
    defaultMessage: '(GMT-08:00) Tijuana, Baja California',
    tz: 'Etc/GMT+8',
  },
  'timezone.gmt-07:00.1': {
    id: 'gmt-07:00-1',
    defaultMessage: '(GMT-07:00) Mountain Time (US & Canada)',
    tz: 'Etc/GMT+7',
  },
  'timezone.gmt-07:00.2': {
    id: 'gmt-07:00-2',
    defaultMessage: '(GMT-07:00) Arizona',
    tz: 'Etc/GMT+7',
  },
  'timezone.gmt-07:00.3': {
    id: 'gmt-07:00-3',
    defaultMessage: '(GMT-07:00) Chihuahua, La Paz, Mazatlan - New',
    tz: 'Etc/GMT+7',
  },
  'timezone.gmt-06:00.1': {
    id: 'gmt-06:00-1',
    defaultMessage: '(GMT-06:00) Central Time (US & Canada)',
    tz: 'Etc/GMT+6',
  },
  'timezone.gmt-06:00.2': {
    id: 'gmt-06:00-2',
    defaultMessage: '(GMT-06:00) Saskatchewan',
    tz: 'Etc/GMT+6',
  },
  'timezone.gmt-06:00.3': {
    id: 'gmt-06:00-3',
    defaultMessage: '(GMT-06:00) Central America',
    tz: 'Etc/GMT+6',
  },
  'timezone.gmt-06:00.4': {
    id: 'gmt-06:00-4',
    defaultMessage: '(GMT-06:00) Guadalajara, Mexico City, Monterrey - Old',
    tz: 'Etc/GMT+6',
  },
  'timezone.gmt-05:00.1': {
    id: 'gmt-05:00-1',
    defaultMessage: '(GMT-05:00) Eastern Time (US & Canada)',
    tz: 'Etc/GMT+5',
  },
  'timezone.gmt-05:00.2': {
    id: 'gmt-05:00-2',
    defaultMessage: '(GMT-05:00) Indiana (East)',
    tz: 'Etc/GMT+5',
  },
  'timezone.gmt-05:00.3': {
    id: 'gmt-05:00-3',
    defaultMessage: '(GMT-05:00) Bogota, Lima, Quito',
    tz: 'Etc/GMT+5',
  },
  'timezone.gmt-04:30.1': {
    id: 'gmt-04:30-1',
    defaultMessage: '(GMT-04:30) Caracas',
    tz: 'America/Caracas',
  },
  'timezone.gmt-04:00.1': {
    id: 'gmt-04:00-1',
    defaultMessage: '(GMT-04:00) Atlantic Time (Canada)',
    tz: 'Etc/GMT+4',
  },
  'timezone.gmt-04:00.2': {
    id: 'gmt-04:00-2',
    defaultMessage: '(GMT-04:00) Georgetown, La Paz, San Juan',
    tz: 'Etc/GMT+4',
  },
  'timezone.gmt-04:00.3': {
    id: 'gmt-04:00-3',
    defaultMessage: '(GMT-04:00) Manaus',
    tz: 'Etc/GMT+4',
  },
  'timezone.gmt-04:00.4': {
    id: 'gmt-04:00-4',
    defaultMessage: '(GMT-04:00) Santiago',
    tz: 'Etc/GMT+4',
  },
  'timezone.gmt-03:30.1': {
    id: 'gmt-03:30-1',
    defaultMessage: '(GMT-03:30) Newfoundland',
    tz: 'America/St_Johns',
  },
  'timezone.gmt-03:00.1': {
    id: 'gmt-03:00-1',
    defaultMessage: '(GMT-03:00) Brasilia',
    tz: 'Etc/GMT+3',
  },
  'timezone.gmt-03:00.2': {
    id: 'gmt-03:00-2',
    defaultMessage: '(GMT-03:00) Buenos Aires',
    tz: 'Etc/GMT+3',
  },
  'timezone.gmt-03:00.3': {
    id: 'gmt-03:00-3',
    defaultMessage: '(GMT-03:00) Cayenne',
    tz: 'Etc/GMT+3',
  },
  'timezone.gmt-03:00.4': {
    id: 'gmt-03:00-4',
    defaultMessage: '(GMT-03:00) Greenland',
    tz: 'Etc/GMT+3',
  },
  'timezone.gmt-03:00.5': {
    id: 'gmt-03:00-5',
    defaultMessage: '(GMT-03:00) Montevideo',
    tz: 'Etc/GMT+3',
  },
  'timezone.gmt-02:00.1': {
    id: 'gmt-02:00-1',
    defaultMessage: '(GMT-02:00) Mid-Atlantic',
    tz: 'Etc/GMT+2',
  },
  'timezone.gmt-01:00.1': {
    id: 'gmt-01:00-1',
    defaultMessage: '(GMT-01:00) Cape Verde Is.',
    tz: 'Etc/GMT+1',
  },
  'timezone.gmt-01:00.2': {
    id: 'gmt-01:00-2',
    defaultMessage: '(GMT-01:00) Azores',
    tz: 'Etc/GMT+1',
  },
  'timezone.gmt.1': {
    id: 'gmt-1',
    defaultMessage:
      '(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London',
    tz: 'Etc/GMT',
  },
  'timezone.gmt.2': {
    id: 'gmt-2',
    defaultMessage: '(GMT) Casablanca',
    tz: 'Etc/GMT',
  },
  'timezone.gmt.3': {
    id: 'gmt-3',
    defaultMessage: '(GMT) Monrovia, Reykjavik',
    tz: 'Etc/GMT',
  },
  'timezone.gmt+01:00.1': {
    id: 'gmt+01:00-1',
    defaultMessage: '(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
    tz: 'Etc/GMT-1',
  },
  'timezone.gmt+01:00.2': {
    id: 'gmt+01:00-2',
    defaultMessage: '(GMT+01:00) Brussels, Copenhagen, Madrid, Paris',
    tz: 'Etc/GMT-1',
  },
  'timezone.gmt+01:00.3': {
    id: 'gmt+01:00-3',
    defaultMessage: '(GMT+01:00) West Central Africa',
    tz: 'Etc/GMT-1',
  },
  'timezone.gmt+01:00.4': {
    id: 'gmt+01:00-4',
    defaultMessage:
      '(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
    tz: 'Etc/GMT-1',
  },
  'timezone.gmt+01:00.5': {
    id: 'gmt+01:00-5',
    defaultMessage:
      '(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
    tz: 'Etc/GMT-1',
  },
  'timezone.gmt+02:00.1': {
    id: 'gmt+02:00-1',
    defaultMessage: '(GMT+02:00) Cairo',
    tz: 'Etc/GMT-2',
  },
  'timezone.gmt+02:00.2': {
    id: 'gmt+02:00-2',
    defaultMessage: '(GMT+02:00) Athens, Bucharest, Istanbul',
    tz: 'Etc/GMT-2',
  },
  'timezone.gmt+02:00.3': {
    id: 'gmt+02:00-3',
    defaultMessage: '(GMT+02:00) Jerusalem',
    tz: 'Etc/GMT-2',
  },
  'timezone.gmt+02:00.4': {
    id: 'gmt+02:00-4',
    defaultMessage: '(GMT+02:00) Amman',
    tz: 'Etc/GMT-2',
  },
  'timezone.gmt+02:00.5': {
    id: 'gmt+02:00-5',
    defaultMessage: '(GMT+02:00) Beirut',
    tz: 'Etc/GMT-2',
  },
  'timezone.gmt+02:00.6': {
    id: 'gmt+02:00-6',
    defaultMessage: '(GMT+02:00) Harare, Pretoria',
    tz: 'Etc/GMT-2',
  },
  'timezone.gmt+02:00.7': {
    id: 'gmt+02:00-7',
    defaultMessage: '(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
    tz: 'Etc/GMT-2',
  },
  'timezone.gmt+02:00.8': {
    id: 'gmt+02:00-8',
    defaultMessage: '(GMT+02:00) Minsk',
    tz: 'Etc/GMT-2',
  },
  'timezone.gmt+02:00.9': {
    id: 'gmt+02:00-9',
    defaultMessage: '(GMT+02:00) Windhoek',
    tz: 'Etc/GMT-2',
  },
  'timezone.gmt+03:00.1': {
    id: 'gmt+03:00-1',
    defaultMessage: '(GMT+03:00) Kuwait, Riyadh',
    tz: 'Etc/GMT-3',
  },
  'timezone.gmt+03:00.2': {
    id: 'gmt+03:00-2',
    defaultMessage: '(GMT+03:00) Moscow, St. Petersburg, Volgograd',
    tz: 'Etc/GMT-3',
  },
  'timezone.gmt+03:00.3': {
    id: 'gmt+03:00-3',
    defaultMessage: '(GMT+03:00) Baghdad',
    tz: 'Etc/GMT-3',
  },
  'timezone.gmt+03:00.4': {
    id: 'gmt+03:00-4',
    defaultMessage: '(GMT+03:00) Nairobi',
    tz: 'Etc/GMT-3',
  },
  'timezone.gmt+03:30.1': {
    id: 'gmt+03:30-1',
    defaultMessage: '(GMT+03:30) Tehran',
    tz: 'Asia/Tehran',
  },
  'timezone.gmt+04:00.1': {
    id: 'gmt+04:00-1',
    defaultMessage: '(GMT+04:00) Abu Dhabi, Muscat',
    tz: 'Etc/GMT-4',
  },
  'timezone.gmt+04:00.2': {
    id: 'gmt+04:00-2',
    defaultMessage: '(GMT+04:00) Baku',
    tz: 'Etc/GMT-4',
  },
  'timezone.gmt+04:00.3': {
    id: 'gmt+04:00-3',
    defaultMessage: '(GMT+04:00) Caucasus Standard Time',
    tz: 'Etc/GMT-4',
  },
  'timezone.gmt+04:00.4': {
    id: 'gmt+04:00-4',
    defaultMessage: '(GMT+04:00) Tbilisi',
    tz: 'Etc/GMT-4',
  },
  'timezone.gmt+04:30.1': {
    id: 'gmt+04:30-1',
    defaultMessage: '(GMT+04:30) Kabul',
    tz: 'Asia/Kabul',
  },
  'timezone.gmt+05:00.1': {
    id: 'gmt+05:00-1',
    defaultMessage: '(GMT+05:00) Islamabad, Karachi',
    tz: 'Etc/GMT-5',
  },
  'timezone.gmt+05:00.2': {
    id: 'gmt+05:00-2',
    defaultMessage: '(GMT+05:00) Ekaterinburg',
    tz: 'Etc/GMT-5',
  },
  'timezone.gmt+05:00.3': {
    id: 'gmt+05:00-3',
    defaultMessage: '(GMT+05:00) Tashkent',
    tz: 'Etc/GMT-5',
  },
  'timezone.gmt+05:30.1': {
    id: 'gmt+05:30-1',
    defaultMessage: '(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi',
    tz: 'Asia/Kolkata',
  },
  'timezone.gmt+05:45.1': {
    id: 'gmt+05:45-1',
    defaultMessage: '(GMT+05:45) Kathmandu',
    tz: 'Asia/Kathmandu',
  },
  'timezone.gmt+06:00.1': {
    id: 'gmt+06:00-1',
    defaultMessage: '(GMT+06:00) Novosibirsk',
    tz: 'Etc/GMT-6',
  },
  'timezone.gmt+06:00.2': {
    id: 'gmt+06:00-2',
    defaultMessage: '(GMT+06:00) Astana, Dhaka',
    tz: 'Etc/GMT-6',
  },
  'timezone.gmt+06:30.1': {
    id: 'gmt+06:30-1',
    defaultMessage: '(GMT+06:30) Yangon (Rangoon)',
    tz: 'Asia/Yangon',
  },
  'timezone.gmt+07:00.1': {
    id: 'gmt+07:00-1',
    defaultMessage: '(GMT+07:00) Bangkok, Hanoi, Jakarta',
    tz: 'Etc/GMT-7',
  },
  'timezone.gmt+07:00.2': {
    id: 'gmt+07:00-2',
    defaultMessage: '(GMT+07:00) Krasnoyarsk',
    tz: 'Etc/GMT-7',
  },
  'timezone.gmt+08:00.1': {
    id: 'gmt+08:00-1',
    defaultMessage: '(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
    tz: 'Etc/GMT-8',
  },
  'timezone.gmt+08:00.2': {
    id: 'gmt+08:00-2',
    defaultMessage: '(GMT+08:00) Kuala Lumpur, Singapore',
    tz: 'Etc/GMT-8',
  },
  'timezone.gmt+08:00.3': {
    id: 'gmt+08:00-3',
    defaultMessage: '(GMT+08:00) Taipei',
    tz: 'Etc/GMT-8',
  },
  'timezone.gmt+08:00.4': {
    id: 'gmt+08:00-4',
    defaultMessage: '(GMT+08:00) Perth',
    tz: 'Etc/GMT-8',
  },
  'timezone.gmt+08:00.5': {
    id: 'gmt+08:00-5',
    defaultMessage: '(GMT+08:00) Irkutsk',
    tz: 'Etc/GMT-8',
  },
  'timezone.gmt+08:00.6': {
    id: 'gmt+08:00-6',
    defaultMessage: '(GMT+08:00) Manila',
    tz: 'Etc/GMT-8',
  },
  'timezone.gmt+09:00.1': {
    id: 'gmt+09:00-1',
    defaultMessage: '(GMT+09:00) Seoul',
    tz: 'Etc/GMT-9',
  },
  'timezone.gmt+09:00.2': {
    id: 'gmt+09:00-2',
    defaultMessage: '(GMT+09:00) Osaka, Sapporo, Tokyo',
    tz: 'Etc/GMT-9',
  },
  'timezone.gmt+09:00.3': {
    id: 'gmt+09:00-3',
    defaultMessage: '(GMT+09:00) Yakutsk',
    tz: 'Etc/GMT-9',
  },
  'timezone.gmt+09:30.1': {
    id: 'gmt+09:30-1',
    defaultMessage: '(GMT+09:30) Darwin',
    tz: 'Australia/Darwin',
  },
  'timezone.gmt+09:30.2': {
    id: 'gmt+09:30-2',
    defaultMessage: '(GMT+09:30) Adelaide',
    tz: 'Australia/Adelaide',
  },
  'timezone.gmt+10:00.1': {
    id: 'gmt+10:00-1',
    defaultMessage: '(GMT+10:00) Canberra, Melbourne, Sydney',
    tz: 'Etc/GMT-10',
  },
  'timezone.gmt+10:00.2': {
    id: 'gmt+10:00-2',
    defaultMessage: '(GMT+10:00) Brisbane',
    tz: 'Etc/GMT-10',
  },
  'timezone.gmt+10:00.3': {
    id: 'gmt+10:00-3',
    defaultMessage: '(GMT+10:00) Hobart',
    tz: 'Etc/GMT-10',
  },
  'timezone.gmt+10:00.4': {
    id: 'gmt+10:00-4',
    defaultMessage: '(GMT+10:00) Guam, Port Moresby',
    tz: 'Etc/GMT-10',
  },
  'timezone.gmt+10:00.5': {
    id: 'gmt+10:00-5',
    defaultMessage: '(GMT+10:00) Vladivostok',
    tz: 'Etc/GMT-10',
  },
  'timezone.gmt+11:00.1': {
    id: 'gmt+11:00-1',
    defaultMessage: '(GMT+11:00) Magadan, Solomon Is., New Caledonia',
    tz: 'Etc/GMT-11',
  },
  'timezone.gmt+12:00.1': {
    id: 'gmt+12:00-1',
    defaultMessage: '(GMT+12:00) Fiji, Marshall Is.',
    tz: 'Etc/GMT-12',
  },
  'timezone.gmt+12:00.2': {
    id: 'gmt+12:00-2',
    defaultMessage: '(GMT+12:00) Auckland, Wellington',
    tz: 'Etc/GMT-12',
  },
  'timezone.gmt+13:00.1': {
    id: 'gmt+13:00-1',
    defaultMessage: "(GMT+13:00) Nuku'alofa",
    tz: 'Pacific/Tongatapu',
  },
});
